import React, {
    useState,
    useCallback,
    useEffect
} from "react";
import {
    Alert,
    Button,
    Modal,
    Spinner
} from "react-bootstrap";
import PropTypes from "prop-types";

function UserVehicleDeleteImageModal({ onDeleteImage, show, handleClose }) {
    const [removing, setRemoving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if(!show) {
            return;
        }
        setRemoving(false);
        setError(null);
    }, [show]);

    const onRemove = useCallback(async () => {
        setError(null);
        setRemoving(true);
        try {
            await onDeleteImage();
        } catch(requestError) {
            console.error(requestError);
            setError("Er is iets fout gegaan. Probeer het later opnieuw.");
            setRemoving(false);
        }
    }, [onDeleteImage]);

    return (
        <Modal
            className="modal-dark"
            show={ show }
            onHide={ handleClose }
        >
            <Modal.Header closeButton>
                <Modal.Title>Afbeelding verwijderen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { error && (
                    <Alert variant="danger">{ error }</Alert>
                )}
                <p className="mb-0">
                    Weet je zeker dat je deze afbeelding wilt verwijderen? Deze actie is niet terug te draaien!
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={ handleClose }
                    disabled={ removing }
                >
                    Annuleren
                </Button>
                <Button
                    variant="danger"
                    onClick={ onRemove }
                    disabled={ removing }
                >
                    { removing && (
                        <Spinner animation="border" size="sm" className="mr-2"/>
                    )}
                    Verwijderen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
UserVehicleDeleteImageModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onDeleteImage: PropTypes.func.isRequired,
};

export default React.memo(UserVehicleDeleteImageModal);
